import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function initPublicationImagesSwiper() {
  const swipers = document.querySelectorAll(".publication-images-swiper");
  if (!swipers.length) return;

  swipers.forEach((el) => {
    const prevButton = el.querySelector(".swiper-button-prev");
    const nextButton = el.querySelector(".swiper-button-next");

    const MD_BREAKPOINT = 744;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: window.innerWidth < MD_BREAKPOINT,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      on: {
        resize(swiper) {
          swiper.allowTouchMove = window.innerWidth < MD_BREAKPOINT;
        },
      },
    });
  });
}
